var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"no-padding"},[_c('label',{staticClass:"question-label"},[_vm._v(_vm._s(_vm.item.name))]),_c('memlist-image-dropzone-upload',{attrs:{"base64_preview":_vm.base64_preview},on:{"uploaded":_vm.on_image_uploaded},model:{value:(_vm.file_id),callback:function ($$v) {_vm.file_id=$$v},expression:"file_id"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }